import React from 'react';
import { Typography } from '@/app/common/Typography/Typography';
import { ContactInfoSidebarProps } from '../interfaces';

export function ContactInfoSidebar({ address, phone, fax }: ContactInfoSidebarProps) {
  return (
    <div className="lg:w-72 flex-shrink-0">
      <div className="md:space-y-lg space-y-md">
        <Typography variant="h4" className="text-heading-large text-secondary-400">
          Australia
        </Typography>

        <div className="md:space-y-md space-y-sm">
          {address && (
            <div className="space-y-xs">
              <Typography as="h3" variant="h6">
                Head Office
              </Typography>
              <Typography variant="bodyMd">{address}</Typography>
            </div>
          )}

          {(phone || fax) && (
            <div className="space-y-xs">
              <Typography as="h3" variant="h6">
                Customer Service/Sales
              </Typography>
              <div>
                {phone && <Typography variant="bodyMd">P: {phone}</Typography>}
                {fax && <Typography variant="bodyMd">F: {fax}</Typography>}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
